<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Stephen, a member of Mensa, was born in 1940 during WWII. Educated at Highgate School, he left at 17 to run a provincial theatre with business partner Robert Stigwood. Back in London they became the paramount musical management company in London in the late ’50s and early ’60s, producing many number one hits. After parting with Robert in 1964, Stephen produced more hits, culminating in his management of Lionel Bart before Bart’s triumph with eleven Oscar Nominations for the film of <em>Oliver</em>. Later Stephen floated six public companies in the UK and USA and created three private property companies. He retired in 2017 to write and to manage his wife, Dr Patti Boulaye OBE. His autobiographical book <em>You’ve Got to Pick a Pocket or Two</em> was published in 2021 by Kaleidoscope Publishing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?887d5aac